import * as Pages                   from '../../infrastructure/views';
import { 
    useRouter,
    useTranslate 
}                                   from './index';

const useRouterResources = ({ route, giveList }) => {
    const router                = useRouter();
    const t                     = useTranslate();

    const resources             = (
        [
            {
                url                 : ['', '/', 'homepage'],
                title               : t('Layout_SideMenu_Homepage'),
                page                : Pages.Landing,
            },
            // {
            //     url                 : [ '/sign-in', 'signin'],
            //     title               : t('Layout_SideMenu_SignIn'),
            //     page                : Pages.SignIn,
            // },
            {
                url                 : [ '/admin'],
                title               : t('Layout_SideMenu_SignIn'),
                page                : Pages.SignIn,
            },
            {
                url                 : ['error'],
                page                : Pages.ErrorPage,
                title               : t('Layout_SideMenu_Error_Page'),
            }
        ]
    )

    return !giveList
                ?   resources.find( r => r.url.includes(route || router.route))
                :   resources
} 

export default useRouterResources;
